<template>
  <div class="spinner-outer" :class="{'spinner-fixed': fixed}">
    <div class="spinner-wrapper">
      <b-spinner />
      <div class="spinner-text">
        {{ text }}
      </div>
    </div>
  </div>
</template>
<script>
  import { BSpinner } from 'bootstrap-vue';
  import 'bootstrap-vue/dist/bootstrap-vue.css';

  export default {
    name: 'GlobalSpinner',
    components: {
      BSpinner
    },
    props: {
      fixed: {
        type: Boolean,
        default: false
      },
      text: {
        type: String,
        default: ''
      },
    }
  };
</script>
<style scoped>

  .spinner-outer {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 9998;
    position: absolute;
    width: 100%;
    text-align: center;
    background: rgba(255, 255, 255, 0.9);
  }

  .spinner-outer.spinner-fixed {
    position: fixed;
  }

  .spinner-outer .spinner-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .spinner-wrapper .spinner-text {
    position: relative;
    text-align: center;
    margin-top: 0.5em;
    z-index: 2;
    width: 100%;
    font-size: 95%;
    color: #337ab7;
  }
</style>